<!-- No facility bar: these figures span every facility the user is associated with, so naming the
     one selected in the header would misdescribe them. Each row names its own facility instead. -->
<pcg-resizable-widget>
    <span widget-title>Awaiting Rx Association</span>

    <div widget-meta>
        @if (isEnabled()) {
            <p-tag
                [value]="count().toString()"
                severity="info"
                [attr.aria-label]="count() + ' applications inside the reconciliation window'"
            />
        }
    </div>

    <!-- Same column as the Requires Review widget: the rows scroll, the note below stays put. The
         two sit side by side, so they must behave the same way when they overflow. -->
    <div class="insulin-body" widget-body>
        @if (isLoading()) {
            <div class="mt-2 pb-1 text-center" aria-live="polite">
                <span class="spinner-border spinner-border-sm align-middle mr-1" aria-hidden="true"></span>
                Loading reconciliation windows...
            </div>
        } @else if (hasError()) {
            <div class="insulin-widget-state text-danger" role="alert">
                <i class="pi pi-exclamation-triangle mr-1" aria-hidden="true"></i>
                These figures could not be loaded. Refresh to try again.
            </div>
        } @else if (!isEnabled()) {
            <div class="insulin-widget-state">
                {{ unavailableMessage() }}
            </div>
        } @else {
            <div class="insulin-rows">
            @for (row of rows(); track row.bcdProgramApplicationId) {
                <pcg-link [href]="statusUrl(row.bcdProgramApplicationId)" [hideStyling]="true">
                    <div class="insulin-row">
                        <div class="insulin-row-main">
                            <div class="insulin-row-name" data-dd-privacy="mask">{{ row.applicantName }}</div>
                            <!-- The two dates that explain the window: why the record is here, and
                                 what the thirty days are counted from. -->
                            <div class="insulin-row-meta">{{ meta(row) }}</div>
                        </div>

                        <div class="insulin-window">
                            <!-- The bar is decorative once the day count below is read out, so it
                                 carries the sentence and nothing repeats it. -->
                            <div
                                class="insulin-window-track"
                                role="img"
                                [attr.aria-label]="windowLabel(row)"
                            >
                                <div
                                    class="insulin-window-fill"
                                    [attr.data-severity]="urgency(row)"
                                    [style.width.%]="percent(row)"
                                ></div>
                            </div>

                            <!-- The urgency in words. "Window closed" and a red bar say the same
                                 thing; only one of them survives greyscale or a screen reader. -->
                            <div class="insulin-window-day" [attr.data-severity]="urgency(row)" aria-hidden="true">
                                @if (row.isHeld) {
                                    Needs review
                                } @else if (row.isExpired) {
                                    Window closed
                                } @else {
                                    Day {{ row.dayOfWindow }}/{{ row.windowLengthDays }}
                                }
                            </div>
                        </div>
                    </div>
                </pcg-link>
            } @empty {
                <div class="insulin-widget-state">
                    No reconciliation windows are open.
                </div>
            }

            @if (count() > rows().length) {
                <div class="insulin-widget-more">
                    Showing the {{ rows().length }} most urgent of {{ count() }}.
                </div>
            }
            </div>
        }
    </div>
</pcg-resizable-widget>
